import React, { JSX } from 'react';

const DEFAULT_RATING_STARS_TOTAL = 5;
export interface Props {
  numberOfStars: number;
  numberTotalOfStars?: number;
  showEmptyStars?: boolean;
}

const StarRating = (props: Props): JSX.Element => {
  const { numberOfStars, numberTotalOfStars = DEFAULT_RATING_STARS_TOTAL, showEmptyStars } = props;

  const totalStar = Math.ceil(showEmptyStars ? numberTotalOfStars : numberOfStars);
  const width = (numberOfStars * 100) / totalStar;
  return (
    <span className="iso__star__rating">
      <span className="iso__star__rating--outer">
        {Array.from(Array(Math.ceil(totalStar)).keys()).map(index => (
          <span style={{ color: '#eee' }} key={index}>
            &#9733;
          </span>
        ))}
        <span style={{ width: `${width.toFixed(2)}%` }} className="iso__star__rating--inner">
          {Array.from(Array(Math.ceil(totalStar)).keys()).map(index => (
            <span style={{ color: '#FFC107' }} key={index}>
              &#9733;
            </span>
          ))}
        </span>
      </span>
    </span>
  );
};

export default StarRating;
